/**
 * @file paddle pilot group 入口
 * @author wanzhongyun
 */

import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import PilotBanner from './components/pilotBanner/PilotBanner';
import PilotAnchor from './components/pilotAnchor/PilotAnchor'
import PilotRights from './components/pilotRights/PilotRights';
import PilotGrowth from './components/pilotGrowth/PilotGrowth';
import PilotSailing from './components/pilotSailing/PilotSailing';
import PilotGroupShow from './components/pilotGroupShow/PilotGroupShow';
import PilotAllGroup from './components/pilotAllGroup/PilotAllGroup';
import PilotFixedQRCode from './components/pilotFixedQRCode/PilotFixedQRCode'

import usePaddlePilotGroupHook from './PaddlePilotGroupHook';


const PaddlePilotGroup: React.FC = () => {
    
    const {
        pilotBanner,
        pilotRights,
        pilotGrowth,
        pilotSailing,
        pilotGroupShow,
        pilotAllGroup,
        pilotQRCode
    } = usePaddlePilotGroupHook();

    return (
        <div>
            <Header />

            <div className="paddle-pilot-wrapper">
                <PilotBanner {...pilotBanner} />
                <PilotAnchor />
                <PilotRights {...pilotRights} />
                <PilotGrowth {...pilotGrowth} />
                <PilotSailing {...pilotSailing} />
                <PilotGroupShow {...pilotGroupShow} />
                <PilotAllGroup {...pilotAllGroup} />
                <PilotFixedQRCode {...pilotQRCode} />
            </div>

            <Footer /> 
        </div>
    );
};

export default PaddlePilotGroup
